<template>
  <div>
    <div class="ml-1 is-size-7">Last Round</div>
      <div
        style="display: inline-block; margin-bottom: 0;"
        class="tags has-addons ml-1"
        v-for="card in round"
        v-bind:key="rand() + card"
      >
        <span class="tag is-dark" style="width: 14px;">{{ card.position | positionToChar }}</span>
        <span class="tag has-text-dark" 
        v-bind:class="{'bid-selected': card.position == roundWinner,
        'has-text-danger': card.card.indexOf('H') > -1 || card.card.indexOf('D') > -1}"
        >{{ card.card | bidToString }}</span>
      </div>
  </div>
</template>

<script>
export default {
  name: "RoundComponent",
  props: {
    round: Array,
    roundWinner: Number
  },
  methods: {
    rand() {
      return Math.random().toString(36).substring(7);
    },
  },
};
</script>

<style></style>
